module.exports = __webpack_public_path__ + "static/img/7.2.b905aca.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/8/1/eng/7.2.png
// module id = UTeZ
// module chunks = 0